import { privateRouteNames } from './privateRoutes'
import { publicRouteNames } from './publicRoutes'
import type { Router } from 'vue-router'

export const validateRoutes = (router: Router) => {
  router.beforeEach((to: any, from, next) => {
    if (to?.name && privateRouteNames.includes(to.name)) {
      if (!localStorage.getItem('token@lifeadmin')) {
        return next({ name: 'login' })
      }

      return next()
    }

    if (to?.name && publicRouteNames.includes(to.name) && localStorage.getItem('token@lifeadmin')) {
      return next({ name: 'dashboard' })
    }

    return next()
  })
}
